import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import PropTypes from "prop-types";
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

function ConfirmationModal({ show, headerTitle, bodyText, closeAction, confirmAction, handleClose, handleConfirm }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth={'sm'}
                open={show}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    <SoftTypography variant="button" fontWeight="medium">
                        {headerTitle}
                    </SoftTypography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <SoftTypography variant="caption" fontWeight="medium" color="text">
                            {bodyText}
                        </SoftTypography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <SoftButton variant="gradient" color={closeAction.color} onClick={handleClose}>
                        {closeAction.title}
                    </SoftButton>
                    <SoftButton variant="gradient" color={confirmAction.color} onClick={handleConfirm}>
                        {confirmAction.title}
                    </SoftButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
ConfirmationModal.defaultProps = {
    show: false,
    headerTitle: '',
    bodyText: '',
    show: false,
    closeAction: {},
    confirmAction: {},
    handleClose: () => {},
    handleConfirm: () => {}
};
ConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    headerTitle: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
    closeAction: PropTypes.any.isRequired,
    confirmAction: PropTypes.any.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired
};

export default ConfirmationModal;
